import React, { useState, useEffect } from "react";
import "./index.css";
import { NewNavbar } from "../../components";
import { BreadCrumbsNew } from "../../components";
import { NewFooter } from "../../components";
import { get } from "../../services/ApiService";
import { useParams, Link } from "react-router-dom";
import PageLoader from "../../components/loader/PageLoader";

const breadcrumbs = [
  { label: "Home", path: "/" },
  { label: "Thank you" },
];

const Thankyou = () => {
  const { id } = useParams();
  const [bookings, setBookings] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [showBloodDrawFee, setShowBloodDrawFee] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await get(`api/booking/${id}`);
      console.log(res);
      if (res.success) {
        const allBookings = res.data;

        let calcSubtotal = 0;
        let shouldAddBloodFee = false;

        allBookings.forEach((booking) => {
          booking.product.forEach((prod, index) => {
            const isBloodTest = booking.section === "blood-test";
            const adjustedPrice = booking.section === "blood-test" && index > 0 ? prod.price - 10 : prod.price;

            calcSubtotal += adjustedPrice;

            // Check if we need to add blood draw fee
            if (
              isBloodTest &&
              prod.name.trim().toLowerCase() !== "blood draw only"
            ) {
              shouldAddBloodFee = true;
            }
          });
        });

        const finalTotal = shouldAddBloodFee ? calcSubtotal + 30 : calcSubtotal;

        setBookings(allBookings);
        setSubtotal(calcSubtotal);
        setTotal(finalTotal);
        setShowBloodDrawFee(shouldAddBloodFee);
        setIsLoading(false);
        setNotFound(false);
      }
      else {
        setIsLoading(false);
        setNotFound(true);
      }
    } catch (error) {
      setIsLoading(false);
      setNotFound(true);
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);
  return (
    <>
      {loading && <PageLoader />}
      <main id="content" className="wrapper layout-page">
        <div className="breadcrumnb-img-bg general-bg">
          <div className="container">
            <NewNavbar />
            <BreadCrumbsNew breadcrumbs={breadcrumbs} title={"Thank you"} />
          </div>
        </div>
        <div className="container mt-6 mb-10">
          {bookings.length > 0 && (
            <>
              <div className="row g-5">
                <div className="col-lg-12">
                  <h5 className="mb-5 metropill-thin mt-8">
                    Thank you for your booking.
                  </h5>
                  <ul className="thankyou-list h6-no-border">
                    <li>
                      <h6 className="mb-0">Order number:</h6>{" "}
                      <span className="metropill">
                        {bookings[0].bookingGroupId}
                      </span>
                    </li>
                    <li>
                      <h6 className="mb-0">Date:</h6>{" "}
                      <span className="metropill">
                        {new Date(bookings[0].bookingDate).toDateString()}
                      </span>
                    </li>
                  </ul>
                  <div className="d-flex align-items-center gap-3 mb-5">
                    <h3 className="mb-15 head-order-details">Booking details</h3>
                  </div>
                  <div className="head-details mb-5">
                    <div className="row">
                      <div className="col-lg-6 col-6">
                        <h4>Product</h4>
                      </div>
                      <div className="col-lg-3 d-none d-lg-block"></div>
                      <div className="col-lg-3 col-6">
                        <h4>Total</h4>
                      </div>
                    </div>
                  </div>
                  <div className="product-body">
                    {bookings.map((booking, bookingIndex) => (
                      <React.Fragment key={bookingIndex}>
                        {booking.product.map((prod, prodIndex) => {
                          const isBloodTest = booking.section === "Blood Test";
                          const displayPrice =
                            isBloodTest && prodIndex > 0
                              ? prod.price - 10
                              : prod.price;

                          return (
                            <div className="body-tr" key={prodIndex}>
                              <div className="row">
                                <div className="col-lg-6">
                                  <h4 className="mt-3">
                                    <a>{prod.name}</a>
                                  </h4>
                                </div>
                                <div className="col-lg-3"></div>
                                <div className="col-lg-3 my-auto">
                                  <h4 className="metropill-thin">
                                    £{displayPrice.toFixed(2)}
                                  </h4>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12">
                                  <hr className="my-5" />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </React.Fragment>
                    ))}

                    <div className="row">
                      <div className="col-lg-6"></div>
                      <div className="col-lg-3">
                        <h4 className="text-end">Subtotal:</h4>
                      </div>
                      <div className="col-lg-3">
                        <h4 className="metropill-thin">£{subtotal}</h4>
                        <hr className="my-5" />
                      </div>
                    </div>
                    {showBloodDrawFee &&
                      <div className="row">
                        <div className="col-lg-6"></div>
                        <div className="col-lg-3">
                          <h4 className="text-end">Blood Draw fee:</h4>
                        </div>
                        <div className="col-lg-3">
                          <h4 className="metropill-thin">£30.00</h4>
                          <hr className="my-5" />
                        </div>
                      </div>
                    }


                    <div className="row">
                      <div className="col-lg-6"></div>
                      <div className="col-lg-3">
                        <h4 className="text-end">Total:</h4>
                      </div>
                      <div className="col-lg-3">
                        <h4 className="metropill-thin">£{total}</h4>
                        <hr className="my-5" />
                      </div>
                    </div>
                    {/* row */}
                  </div>
                  {/* body */}
                  {/* <div className="bottom-content mt-15 mb-10">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="d-flex align-items-center gap-3 mb-5">
                          <h3 className="mb-5 head-order-details">
                            Billing address
                          </h3>
                        </div>
                        <div className="order-det-box">
                          <h4>test test</h4>
                          <h4>test</h4>
                          <h4>3223</h4>
                          <h4>abu dhabi</h4>
                          <h4>United Arab Emirates</h4>
                          <h4>
                            <i className="fas fa-phone"></i> +45512512112
                          </h4>
                          <h4>
                            <i className="fas fa-envelope"></i> test@tes.com
                          </h4>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="d-flex align-items-center gap-3 mb-5">
                          <h3 className="mb-5 head-order-details">
                            Shipping address
                          </h3>
                        </div>
                        <div className="order-det-box">
                          <h4>test test</h4>
                          <h4>test</h4>
                          <h4>3223</h4>
                          <h4>abu dhabi</h4>
                          <h4>United Arab Emirates</h4>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="mt-30 mb-4 p-0 card-footer bg-transparent border-0 d-flex align-items-center justify-content-center gap-2">
                <Link to={`/`} className="btncust w-auto activebg m-auto">Back to Home</Link>
              </div>
            </>
          )}
          {notFound && (
            <div
              className="row p-5"
              style={{ marginTop: "100px", marginBottom: "100px" }}
            >
              <div className="col-lg-2 col-12"></div>
              <div className="col-lg-4 col-12 ">
                <img
                  src="/assets/images/empty-cart.png"
                  alt=""
                  style={{ width: "250px" }}
                />
              </div>
              <div className="col-lg-4 col-12">
                <div>
                  <h2 className="mt-lg-0 mt-10 mb-10">Sorry...</h2>
                  <p className="error-desc metropill mb-12">
                    We couldn't find your booking. Please contact support if you
                    believe this is an error.
                  </p>
                  <Link
                    to={"/"}
                    className="btncust btn-pad w-auto d-inline-block text-decoration-none metropill"
                  >
                    Explore
                  </Link>
                </div>
              </div>
              <div className="col-lg-2 col-12"></div>
            </div>
          )}
        </div>
        <NewFooter />
      </main>
    </>
  );
};

export default Thankyou;
